export class RecognizedPhrase {
    public stablePhrase: string | null = null;
    public unstablePhraseFragments: string[] = [];
    public state: State = new State();
    constructor() {
    }

    /**
     * Compares a phrase vs a phrase that was already said, and returns the fragment that was not said yet
     * @param phraseToCurate
     * @param phraseLastSaid
     */
    public static curatePhrase(phraseToCurate: string, phraseLastSaid: string): string {
        //alreadySaid: i = 0 -> i = unstableFragmentAlreadySaidIndex
        //nextToSay: unstablePhraseFragments[unstableFragmentIndex + 1] - unstablePhraseFragments[unstableFragmentIndex] || stablePhrase - unstablePhraseFragments[i = unstableFragmentIndex]
        //hola, [l 1, idx 0] [idx -1]
        //hola, como?
        //hola, como? | soy diego. [2]
        //hola, como estas? | soy diego. | y vos? [3]
        ////hola, como estas? soy diego. y vos? bien, gracias. yo soy pamela.
        //
        //1. la frase que voy a curar la divido en fragmentos por puntuacion
        //2. la frase que ya dije la divido en fragmentos por puntuacion
        //3. me fijo la longitud del array de tokens de la que ya dije [2], le resto 1 idx [1]
        //4. la que voy a decir, me quedo a partir del idx + 1 si es que no es null

        //1.
        //Process to curate
        //console.log("removeAlreadySaid 1. toCurate ", phraseToCurate);
        const phraseToCurateTokens = phraseToCurate?.match(/[^.;?!]+[.;?!]?/g);
        if (!phraseToCurateTokens)
            return '';
        const lastTokenToCurate = phraseToCurateTokens[phraseToCurateTokens.length - 1];
        if (!['.', ';', '?', '!'].includes(lastTokenToCurate.charAt(lastTokenToCurate.length - 1))) {
            phraseToCurateTokens.pop();
        }
        if (!(!!phraseLastSaid)) {
            return phraseToCurateTokens.join(' ');
        }
        console.log("removeAlreadySaid 1. tokenized ", phraseToCurateTokens);

        //Process already said
        console.log("removeAlreadySaid 2. lastSaid ", phraseLastSaid);
        const phraseLastSaidTokens = phraseLastSaid?.match(/[^.;?!]+[.;?!]?/g);
        console.log("removeAlreadySaid 2. tokenized ", phraseLastSaidTokens);
        if (phraseLastSaidTokens && phraseLastSaidTokens?.length > 0) {
            const lastTokenLastSaid = phraseLastSaidTokens[phraseLastSaidTokens.length - 1];
            if (!['.', ';', '?', '!'].includes(lastTokenLastSaid.charAt(lastTokenLastSaid.length - 1))) {
                phraseLastSaidTokens.pop();
            }
        }

        if (phraseToCurateTokens.length - 1 < (phraseLastSaidTokens?.length || 0)) {
            return '';
        }

        return phraseToCurateTokens.slice(((phraseLastSaidTokens?.length)) || 0).join('');

    }

}

class State {
    public isCurrentlySpeaking: boolean = false;
    public isSpeakingUsingUnstablePhrase: boolean = false;
    public unstableFragmentAlreadySaidIndex: number = -1;
    constructor() {
    }
}
